export const QUERY_KEY_VOYAGE_TEMPLATES_SINGLE_VOYAGES = 'voyageTemplatesSingleVoyages'
export const QUERY_KEY_VOYAGE_TEMPLATE_BY_ID_SINGLE_VOYAGES = 'voyageTemplateByIdSingleVoyages'
export const QUERY_KEY_VOYAGE_TEMPLATE_SYNC_PREVIEW_SINGLE_VOYAGES = 'voyageTemplateSyncPreviewSingleVoyages'
export const QUERY_KEY_VOYAGE_TEMPLATE_OUTDATED_SINGLE_VOYAGES = 'voyageTemplateOutdatedSingleVoyages'
